export const CREATE_SPOT_FAILURE = 'CREATE_SPOT_FAILURE';

export const createSpotFailure = (payload: Error) => ({
    type: CREATE_SPOT_FAILURE,
    payload,
});
